// local imports
import { AdLoader } from './ads/loader';
import { lazyload } from './utils/lazyload';
import $ from 'jquery';
import { slick } from './utils/slick.min.js';

// !function(i)

// !function(i)

// we conditionally do this so it gets removed in the modern build entirely
// dynamic imports get inlined in the legacy build so that's handled too, nifty!
if (process.env.LEGACY_BUILD) {
  import('intersection-observer');
}

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart lazy loading
  lazyload();
  slick();

  // Kickstart the ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});
